import React from "react";

const ExcelIcon = ({
  size = 20,
  className,
}: {
  size?: number | string;
  className?: string;
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <rect width="20" height="20" fill="white" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.3034 3.16258H11.5149V1.79688L2 3.26728V16.156L11.5149 17.7969V15.7726H17.3034C17.4787 15.7815 17.6504 15.7205 17.781 15.603C17.9115 15.4855 17.9903 15.321 18 15.1456V3.78908C17.9901 3.6137 17.9113 3.44936 17.7808 3.33197C17.6503 3.21458 17.4786 3.15369 17.3034 3.16258ZM17.3949 15.2497H11.4954L11.4857 14.1689H12.9069V12.9102H11.4749L11.468 12.1664H12.9069V10.9077H11.4571L11.4503 10.1639H12.9069V8.90519H11.4457V8.1614H12.9069V6.90269H11.4457V6.1589H12.9069V4.90018H11.4457V3.7559H17.3949V15.2497Z"
        fill="#20744A"
      />
      <path
        d="M14 4.79688H16V6.15456H14V4.79688ZM14 6.95745H16V8.31514H14V6.95745ZM14 9.11803H16V10.4757H14V9.11803ZM14 11.2786H16V12.6363H14V11.2786ZM14 13.4392H16V14.7969H14V13.4392Z"
        fill="#20744A"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.12401 7.0239L5.57029 6.95392L6.47944 9.0643L7.55371 6.86686L9 6.79688L7.2437 9.79318L9 12.7969L7.47082 12.7098L6.43833 10.4202L5.40518 12.6228L4 12.5181L5.6323 9.86487L4.12401 7.0239Z"
        fill="white"
      />
    </svg>
  );
};

export default ExcelIcon;
